import { render, staticRenderFns } from "./BankInstructionCreateEdit.vue?vue&type=template&id=24522b7f&scoped=true&"
import script from "./BankInstructionCreateEdit.vue?vue&type=script&lang=js&"
export * from "./BankInstructionCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./BankInstructionCreateEdit.vue?vue&type=style&index=0&id=24522b7f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24522b7f",
  null
  
)

export default component.exports